<template>
  <div :class="{ mobile: isMobile }">
    <div class="title-wrapper">
      <span class="title" :class="{ active: index === 0 }" @click="index = 0"
        >History</span
      >
      <span class="title" :class="{ active: index === 1 }" @click="index = 1"
        >Filters</span
      >
      <span class="title" :class="{ active: index === 2 }" @click="index = 2"
        >Triggers</span
      >
      <span class="title" :class="{ active: index === 3 }" @click="index = 3"
        >Notifications</span
      >
    </div>
    <div v-if="index === 0" class="content-wrapper">
      <HistoryTable :historyDataList="historyDataList"></HistoryTable>
    </div>
    <div v-if="index === 1" class="content-wrapper">
      <TriggerTable
        :triggerDataList="alertDataObj.triggerDataList"
        @onViewTriggerHistory="viewTriggerHistory"
      ></TriggerTable>
    </div>
    <div v-if="index === 2" class="content-wrapper">
      <Rules
        :triggerOnNumHits="alertDataObj.triggerOnNumHits"
        :triggerOnFirstHit="alertDataObj.triggerOnFirstHit"
      ></Rules>
    </div>
    <div v-if="index === 3" class="content-wrapper">
      <Actions :actionDataList="actionDataList"></Actions>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import HistoryTable from './HistoryTable.vue';
import TriggerTable from './TriggerTable.vue';
import Rules from './Rules.vue';
import Actions from './Actions.vue';
import { ALERTS_REQUEST } from '../../../../constants/alertsConstant';

export default {
  name: 'AlertDetailContainer',
  components: { HistoryTable, TriggerTable, Rules, Actions },
  props: {
    alertDataObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      index: 0,
      historyDataList: []
    };
  },
  watch: {
    'alertDataObj.historyDataList': {
      immediate: true,
      deep: true,
      handler(val) {
        if (!Array.isArray(val) || val.length === 0) return;

        this.historyDataList = val.map(item => ({
          ...item,
          trigger: Array.isArray(item.trigger)
            ? item.trigger.join(', ')
            : item.trigger
        }));
      }
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapGetters('authStore', ['oidcUser']),
    ...mapGetters('alertsSuspiciousTrafficStore', [
      'memberContactsOfSelectedAccount'
    ]),
    actionDataList() {
      if (this.alertDataObj.actions && this.alertDataObj.actions.length) {
        const actions = this.alertDataObj.actions;

        const actionList = actions.map(item => {
          let channel = '';

          switch (item.channel) {
            case ALERTS_REQUEST.channel.email:
              channel = 'Email';
              break;
            case ALERTS_REQUEST.channel.sms:
              channel = 'SMS';
              break;
            case ALERTS_REQUEST.channel.slack:
              channel = 'Slack';
              break;
            default:
              break;
          }

          if (item.recipient && item.recipient.nonApnicUser) {
            return {
              channel,
              recipient: item.recipient.nonApnicUser
            };
          } else if (item.recipient && item.recipient.apnicUser) {
            const apnicUser = item.recipient.apnicUser;
            if (apnicUser === this.oidcUser.userid) {
              return {
                channel,
                recipient: `${this.oidcUser.nickname ||
                  this.oidcUser.email} (myself)`
              };
            } else {
              const member = this.memberContactsOfSelectedAccount.find(
                member => apnicUser === member.uid
              );
              return {
                channel,
                recipient: member && member.name
              };
            }
          }
        });

        // Filter list by checking whether the value of recipient is falsy.
        const list = actionList.filter(item => !!item.recipient);

        return list;
      }
    }
  },
  methods: {
    ...mapActions('alertsSuspiciousTrafficStore', ['fetchTrigger']),
    ...mapMutations('alertsSuspiciousTrafficStore', [
      'setSelectedTriggerWithAlertInfo'
    ]),
    viewTriggerHistory(trigger) {
      const { alertId, name } = this.alertDataObj;

      this.fetchTrigger({ trigger, isTriggerOfSelectedAlert: true });

      this.setSelectedTriggerWithAlertInfo({
        trigger,
        alertId,
        alertName: name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title-wrapper {
  margin-bottom: 0.5rem;
  border-bottom: 1px solid $border-grey;

  .title {
    display: inline-block;
    margin: 0 1rem;
    padding: 0.5rem;
    padding-top: 0;
    cursor: pointer;

    &.active {
      border-bottom: 2px solid $text-light-blue;
    }
  }

  .title:nth-child(1) {
    margin-left: 0;
  }
}

.content-wrapper {
  margin: 0 0.5rem;
}

.mobile {
  .title-wrapper {
    display: flex;
    justify-content: space-between;

    .title {
      padding: 0.25rem;
      margin: 0 0.25rem;
    }

    .title:nth-child(1) {
      margin-left: 0;
    }
  }
}
</style>
